<template>
  <div>
    <h3>沟通记录</h3>

    <el-table :data="list" size="mini" v-loading="loading">
      <el-table-column prop="sender" label="发信方id"></el-table-column>
      <el-table-column prop="senderName" label="发信方昵称"></el-table-column>
      <el-table-column prop="senderRole" label="发信方角色">
        <template slot-scope="scope">{{
          scope.row.senderRole === 1 ? "甲方" : "乙方"
        }}</template>
      </el-table-column>
      <el-table-column prop="receiver" label="收信方id"></el-table-column>
      <el-table-column prop="receiverName" label="收信方昵称"></el-table-column>
      <el-table-column prop="receiverRole" label="收信方角色">
        <template slot-scope="scope">{{
          scope.row.receiverRole === 1 ? "甲方" : "乙方"
        }}</template>
      </el-table-column>
      <el-table-column prop="bodies" label="消息内容" width="500">
        <template slot-scope="scope">
          <template>{{ JSON.stringify(scope.row.bodies) }}</template>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <template>{{ scope.row.status === 1 ? "已读" : "未读" }}</template>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="沟通时间"></el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import map from "../../datamap";

import api from "../api";
let { user } = api;
export default {
  name: "msgs",
  data() {
    return {
      map,
      loading: true,
      list: [],
      total: 0,
      pageNum: 1,
      limit: 100,
    };
  },
  computed: {
    senderId() {
      return this.$route.query.senderId;
    },
    receiverId() {
      return this.$route.query.receiverId;
    },
    sessionId() {
      return this.$route.query.sessionId;
    },
    sender() {
      return this.$route.query.partyA;
    },
    receiver() {
      return this.$route.query.partyB;
    },
  },
  watch: {
    pageNum() {
      this.fetch();
    },
  },
  created() {},
  methods: {
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }

      this.loading = true;
      let {
        data: { data, code, desc, pageinfo },
      } = await user.msgs({
        pageNum: this.pageNum,
        limit: this.limit,
        conversationId: this.sessionId,
        sender: this.sender,
        receiver: this.receiver,
      });
      if (code == 200) {
        this.list = data;
        this.total = pageinfo.totalCount;
      }
      this.loading = false;
    },
    // async exportExcel() {

    //     let {
    //         senderId,
    //         receiverId,
    //         createTimeStart,
    //         createTimeEnd,
    //         content,
    //     } = this.filter;

    //     this.loading = true;

    //     let resp = await user.exportMsgs({
    //         senderId,
    //         receiverId,
    //         createTimeStart,
    //         createTimeEnd,
    //         content,
    //     })
    //     let objectUrl = URL.createObjectURL(new Blob([resp.data]))
    //     let link = document.createElement('a')
    //     link.download = decodeURIComponent('沟通记录表.xlsx')
    //     link.href = objectUrl
    //     link.click()
    //     this.loading = false
    // },
  },
  mounted() {
    this.fetch();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/user/msgs.vue